import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "./context/AuthContext";

// Public Pages
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPasswordConfirm from "./pages/ResetPasswordConfirm";
import FeaturesPage from "./pages/FeaturesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import SetPassword from "./pages/SetPassword";

// Private Pages / Components
import FrameworkPage from "./pages/FrameworkPage";
import COBITInstructions from "./components/COBITInstructions";
import BCMInstructions from "./components/BCMInstructions";
import COBITAssessmentDashboardPage from "./pages/COBITAssessmentDashboardPage";
import BCMAssessmentDashboardPage from "./pages/BCMAssessmentDashboardPage";
import COBITAssessmentForm from "./components/COBITAssessmentForm";
import BCMAssessmentForm from "./components/BCMAssessmentForm";
import COBITReport from "./components/COBITReport";
import BCMReport from "./components/BCMReport";

import Layout from "./components/Layout";

// ---------------------------
// PrivateRoute using AuthContext
// ---------------------------
const PrivateRoute = () => {
  const { user } = useAuth();
  const location = useLocation();

  return user ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location.pathname }} replace />
  );
};

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={5000} />

      <Routes>
        {/* Public Routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordConfirm />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route path="/frameworks" element={<FrameworkPage />} />
            <Route path="/cobit/instructions" element={<COBITInstructions />} />
            <Route path="/bcm/instructions" element={<BCMInstructions />} />
            <Route path="/cobit/assessment" element={<COBITAssessmentForm />} />
            <Route path="/bcm/assessment" element={<BCMAssessmentForm />} />
            <Route path="/cobit/dashboard" element={<COBITAssessmentDashboardPage type="cobit" />} />
            <Route path="/bcm/dashboard" element={<BCMAssessmentDashboardPage type="bcm" />} />
            <Route path="/cobit/report" element={<COBITReport type="cobit" />} />
            <Route path="/bcm/report" element={<BCMReport type="bcm" />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
